import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface FolderDeduplicatedCountResponse {
  count: number;
}

/**
 * Lazy fetcher for the count of files that were deduplicated from a folder
 * subtree. Used on the docs page to decide whether to prompt the user when
 * creating a Subset from a folder.
 */
export const useGetFolderDeduplicatedCount = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return async (matterId: string, folderId: string): Promise<FolderDeduplicatedCountResponse> => {
    const res = await fetch(
      `${APIBaseChronos}/api/matters/${matterId}/folder/${folderId}/deduplicated-count`,
      fetchConfigGET,
    );
    if (!res.ok) {
      throw new Error('Network response was not ok');
    }
    return res.json();
  };
};
